import React from "react"
import SbEditable from "storyblok-react"
import Markdown from "react-markdown"
import { Locations, transformLinkUri } from "gatsby-theme-gba"

const apiKey = process.env.GATSBY_GOOGLE_MAP_API

const prepareLocations = (locations, blok) => {
  for (let i = 0; i < locations.length; i++) {
    if (locations[i]["body"]) {
      locations[i]["body"] = (
        <Markdown
          source={locations[i]["body"]}
          transformLinkUri={uri => {
            return transformLinkUri(
              uri,
              "",
              blok.currentLanguage,
              blok.seoLinks
            )
          }}
        />
      )
    }
  }
  return locations
}

const LocationsEditable = ({ blok }) => (
  <SbEditable content={blok}>
    <Locations
      heading={blok.heading}
      mode={blok.mode}
      centerLng={Number(blok.centerLng)}
      ceneterLat={Number(blok.centerLat)}
      zoomLevel={Number(blok.zoom)}
      location={prepareLocations(blok.location, blok)}
      apiKey={apiKey}
      currentLanguage={blok.currentLanguage}
      seoLinks={blok.seoLinks}
      hideMap={blok.hideMap}
      hideLocations={blok.hideLocations}
    />
  </SbEditable>
)

export default LocationsEditable
